import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import WhoWeAre from "./sections/WhoWeAre";
import Biography from "./sections/Biography";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <WhoWeAre />
      <Biography />
      <Footer />
    </div>;
}